// const formatTime = (timeString) => {
// 	let splitTimeString = timeString.split(":");
// 	return `${splitTimeString[0]}:${splitTimeString[1]}`;
// };

const formatTime = (timestamp) => {
	let date_time = new Date(timestamp);
	var minutes = date_time.toTimeString().slice(3, 5); 
	var hours   = date_time.toTimeString().slice(0, 2); 

	return hours+':'+minutes
};


export default formatTime
